import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "container"]
  static values = {
    name: String,
    existing: Array
  }

  connect() {
    this.tags = []

    // Load existing tags if provided
    if (this.hasExistingValue && this.existingValue.length > 0) {
      this.tags = [...this.existingValue]
      this.renderTags()
    }
  }

  addTag(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      const value = this.inputTarget.value.trim()

      if (value && !this.tags.includes(value)) {
        this.tags.push(value)
        this.inputTarget.value = ""
        this.renderTags()
      }
    }
  }

  removeTag(event) {
    const tagValue = event.currentTarget.dataset.tagValue
    this.tags = this.tags.filter(tag => tag !== tagValue)
    this.renderTags()
  }

  renderTags() {
    this.containerTarget.innerHTML = ""

    this.tags.forEach(tag => {
      const tagElement = document.createElement("div")
      tagElement.className = "inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800"
      tagElement.innerHTML = `
        <span>${this.escapeHtml(tag)}</span>
        <button type="button"
                data-action="click->tags#removeTag"
                data-tag-value="${this.escapeHtml(tag)}"
                class="ml-2 inline-flex items-center justify-center w-4 h-4 text-blue-600 hover:text-blue-800 focus:outline-none">
          <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
          </svg>
        </button>
      `
      this.containerTarget.appendChild(tagElement)

      // Create hidden input for form submission
      const hiddenInput = document.createElement("input")
      hiddenInput.type = "hidden"
      hiddenInput.name = this.nameValue
      hiddenInput.value = tag
      this.containerTarget.appendChild(hiddenInput)
    })
  }

  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}
